const MAP_STYLES = [{
		"featureType": "landscape.man_made",
		"elementType": "geometry",
		"stylers": [{
			"color": "#dff7e0"
		}]
	},
	{
		"featureType": "landscape.natural",
		"elementType": "geometry",
		"stylers": [{
			"color": "#b4e3c3"
		}]
	},
	{
		"featureType": "landscape.natural.terrain",
		"elementType": "geometry",
		"stylers": [{
			"visibility": "off"
		}]
	},
	{
		"featureType": "poi",
		"elementType": "labels",
		"stylers": [{
			"visibility": "off"
		}]
	},
	{
		"featureType": "poi.business",
		"elementType": "all",
		"stylers": [{
			"visibility": "off"
		}]
	},
	{
		"featureType": "poi.medical",
		"elementType": "geometry",
		"stylers": [{
			"color": "#fbd3da"
		}]
	},
	{
		"featureType": "poi.park",
		"elementType": "geometry",
		"stylers": [{
			"color": "#bde6ab"
		}]
	},
	{
		"featureType": "road",
		"elementType": "geometry.stroke",
		"stylers": [{
			"visibility": "off"
		}]
	},
	{
		"featureType": "road",
		"elementType": "labels",
		"stylers": [{
			"visibility": "off"
		}]
	},
	{
		"featureType": "road.highway",
		"elementType": "geometry.fill",
		"stylers": [{
			"color": "#e2e2e2"
		}]
	},
	{
		"featureType": "road.highway",
		"elementType": "geometry.stroke",
		"stylers": [{
			"color": "#ffffff"
		}]
	},
	{
		"featureType": "road.arterial",
		"elementType": "geometry.fill",
		"stylers": [{
			"color": "#ffffff"
		}]
	},
	{
		"featureType": "road.local",
		"elementType": "geometry.fill",
		"stylers": [{
			"color": "black"
		}]
	},
	{
		"featureType": "transit.station.airport",
		"elementType": "geometry.fill",
		"stylers": [{
			"color": "#aaaaaa"
		}]
	},
	{
		"featureType": "water",
		"elementType": "geometry",
		"stylers": [{
			"color": "#7AB1D5"
		}]
	}
];

const API_KEY = 'AIzaSyC55-dJ2_JFB4th7TXZ0tjyFJRNfdzd8zY';
const markerIcon = '/styles/images/infrastructure/markerIcon.png';

const ALL_INFRASTRUCTURE_TYPE = 'all'
const INFRASTRUCTURE_TYPE_ATTRIBUTE = 'data-infrastructure-type';;
const ACTIVE_BUTTON_CLASS = 'active';
const BUTTON_FILTER_SELECTOR = `button.filter[${INFRASTRUCTURE_TYPE_ATTRIBUTE}]`;

const initInfrastructure = () => {
	const components = document.querySelectorAll( 'section.infrastructure' );
	
	if ( !components.length )
	{
		return;
	}

	const script = document.createElement(`script`);
	script.src = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}`;
	document.body.appendChild(script);

	script.addEventListener(`load`, () => {
		components.forEach( ( component ) => {
			const mapWrapper = component.querySelector( 'div.google-map' );
			const latitude = mapWrapper.getAttribute( 'data-map-latitude' );
			const longitude = mapWrapper.getAttribute( 'data-map-longitude' );
			const zoom = mapWrapper.getAttribute( 'data-map-zoom' );

			const markers = [];

			const init = () => {
				const mapOptions = {
					zoom: +zoom,
					center: new google.maps.LatLng(latitude, longitude),
					styles: MAP_STYLES,
					disableDefaultUI: true,
				};

				const map = new google.maps.Map(mapWrapper, mapOptions);

				const marker = new google.maps.Marker({
					position: new google.maps.LatLng(latitude, longitude),
					map: map,
					title: 'Harmony',
					icon: markerIcon,
				});

				const filtersListNode = component.querySelector( 'ul.filters' );
				const placemarksWrapper = component.querySelector( 'ul.placemarks' );

				if ( !filtersListNode || !placemarksWrapper )
				{
					return;
				}

				filtersListNode.addEventListener('click', ({ target }) => {
					if (target.closest('li > button')) {
						target.closest('li > button').classList.toggle('active');
						const type = target.closest('li > button').getAttribute('data-infrastructure-type');

						if ( type === 'all' )
						{
							if ( target.closest('li > button').classList.contains( 'active' ) )
							{
								filtersListNode.querySelectorAll( 'button.active' ).forEach( ( item ) => item.classList.remove( 'active' ) );
								target.closest('li > button').classList.toggle('active');

								markers.forEach((marker) => {
									marker.setVisible( false );
								});
								target.closest('li > button').textContent = 'Показать все'
							}
							else
							{
								markers.forEach((marker) => {
									marker.setVisible( true );
								});

								target.closest('li > button').textContent = 'Скрыть все'
							}
						}

						markers.forEach((marker) => {
							const markerType = marker.get("type");

							if (markerType === type) {
								marker.setVisible(!marker.getVisible());
							}
						});
					}
				});

				const infoWindow = new google.maps.InfoWindow();

				placemarksWrapper.querySelectorAll('li').forEach((placemarkNodeInfoWrapper) => {
					const marker = new google.maps.Marker({
						position: new google.maps.LatLng(placemarkNodeInfoWrapper.dataset.latitude, placemarkNodeInfoWrapper.dataset.longitude),
						map: map,
						title: placemarkNodeInfoWrapper.dataset.title,
						icon: placemarkNodeInfoWrapper.dataset.icon,
						optimized: false,
					});

					marker.set( 'type', placemarkNodeInfoWrapper.dataset.type );

					markers.push(marker);

					marker.addListener("click", () => {
						infoWindow.close();
						infoWindow.setContent(marker.getTitle());
						infoWindow.open(marker.getMap(), marker);
					});
				});
			}

			google.maps.event.addDomListener(window, 'load', init);
		} );
	});
};

export {
	initInfrastructure,
}
